module.exports = __webpack_public_path__ + "assets/digicert.4f669954.svg";